import React from 'react';
import {Spinner} from '../../modules/spinner';
import {NoData} from '../../components/no-data';
import {Props} from './type';

const SpinnerNoData = (props: Props) => {
    return (
        <>
            {props.loading ?
                <Spinner />
                :
                <NoData
                    title={props.title}
                    message={props.message}
                />
            }
        </>
    );
};

export default SpinnerNoData;
